import { cva, type VariantProps } from "class-variance-authority";

export const buttonVariants = cva(
  [
    "inline-flex shrink-0 cursor-pointer items-center justify-center gap-2 rounded-input font-medium whitespace-nowrap",
    "transition-colors select-none",
    "aria-busy:cursor-progress data-disabled:cursor-not-allowed data-disabled:not-aria-busy:opacity-45",
  ],
  {
    variants: {
      variant: {
        primary: "bg-accent text-on-accent hover:bg-accent/90",
        secondary: "border border-line-strong bg-surface text-ink hover:bg-surface-sunken",
        ghost: "text-accent hover:bg-accent-soft",
        destructive: "text-critical hover:bg-critical-soft",
      },
      size: {
        sm: "h-8 px-3 text-label",
        md: "h-10 px-4 text-body coarse:h-11",
        lg: "h-12 w-full px-5 text-title font-medium",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);

export type ButtonVariants = VariantProps<typeof buttonVariants>;
